import { route } from '@betterment/js-runtime';

import brochureUrl from './brochureUrl';

export const urlBuilder = {
  graphQL: route('', ['/graphql']),
  dashboard: route('', ['/dashboard']),
  tasks: route('', ['/tasks']),
  plan: route('', ['/plan']),
  support: route('', ['/support']),
  profile: route('', ['profile']),
  profileEmailPreferencesEdit: route('', ['profile', 'email_preferences', 'edit']),
  reports: route('', ['reports']),
  reportsNew: route('', ['reports', 'new']),
  employee: route('', ['employees', { param: 'employeeId' }]),
  employees: route('', ['employees']),
  payroll: route('', ['payroll_overview']),
  compliance: route('', ['compliance']),
  currentEmployer: route('', ['current_employer', { param: 'employerId' }]),
  signOut: route('', ['plan_managers', 'sign_out']),

  // NOTE: These currently link to the same location. They will diverge in the future.
  help: route('', ['education']),
  resources: route('', ['education']),

  getReportCsvDownload(reportId: string) {
    return `/reports/${reportId}.csv`;
  },
  getDeconversionPackageDownload() {
    return '/plan_reports/deconversion_package';
  },
  getSignablePackageDownload(signablePackageId: string) {
    return `/signable_package_download/${signablePackageId}`;
  },
  getSignablePackageSuccess(signablePackageId: string, returnToPath?: string) {
    return `/signable_packages/${signablePackageId}/success${returnToPath ? `?returnTo=${encodeURIComponent(returnToPath)}` : ''}`;
  },
  getUnallocatedFundsGuide() {
    return brochureUrl('/work/resources/what-are-unallocated-funds');
  },
};
